import { Injectable } from '@angular/core';

export enum Password {
  bypassBlockedClient = 1,
  generateLoginPassword = 2,
}

export const hebrewDictionary = {
  a: 'ש',
  b: 'נ',
  c: 'ב',
  d: 'ג',
  e: 'ק',
  f: 'כ',
  g: 'ע',
  h: 'י',
  i: 'ן',
  j: 'ח',
  k: 'ל',
  l: 'ך',
  m: 'צ',
  n: 'מ',
  o: 'ם',
  p: 'פ',
  q: '/',
  r: 'ר',
  s: 'ד',
  t: 'א',
  u: 'ו',
  v: 'ה',
  w: "'",
  x: 'ס',
  y: 'ט',
  z: 'ז',
  ',': 'ת',
  '.': 'ץ',
} as const;

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  constructor() {}

  async getPasswordPIN(
    AgentID: string,
    CompanyNumber: string,
    company: number,
    action: number,
    length: number
  ): Promise<string> {
    // Convert date to UTC YYYYMMDD format
    const dateStr = new Date().toISOString().slice(0, 10);

    // Combine variables into a single string
    const inputStr =
      AgentID + CompanyNumber + company.toString() + dateStr + action;

    // Calculate a hash value using SHA-256 algorithm
    const msgUint8 = new TextEncoder().encode(inputStr);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');

    // Extract first 4 digits from the hash value
    const pin = parseInt(hashHex.slice(0, length), 16);

    // Return the pin as a string with leading zeros
    return pin.toString().padStart(6, '0');
  }
}
